"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$attrs = void 0;
exports.$in = $in;
exports.$inout = $inout;
exports.$isDesc = $isDesc;
exports.$out = $out;
exports.default = exports.ACTION_NAME_DESC_COMPONENT = exports.ACTION_NAME_DESC = void 0;

var _mobx = require("mobx");

var _utils = require("./utils");

var _excluded = ["bind"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var ACTION_NAME_DESC_COMPONENT = 'DESC_COMPONENT';
exports.ACTION_NAME_DESC_COMPONENT = ACTION_NAME_DESC_COMPONENT;
var ACTION_NAME_DESC = 'DESC';
/**
 * 
 * @param {*} obj 
 * @param {*} value 
 * @param {*} actionName 
 */

exports.ACTION_NAME_DESC = ACTION_NAME_DESC;

function setValue(obj, value, actionName) {
  var desc = obj.$out;

  if ((!desc || typeof desc === "string" && desc.trim() === "") && this.name) {
    desc = obj.name;
  }

  if (desc && typeof desc === 'string') {
    desc = desc.match(/[,|]+/) ? desc.split(/[,|]+/) : desc;
  }

  if (typeof desc === "function") {
    desc(value, obj.bind, actionName);
  } else if (typeof desc === 'string' && desc.length) {
    (0, _utils.setObjByPath)(obj.bind, desc, value, false);
  } else if ((0, _utils.isObject)(desc)) {
    for (var key in desc) {
      var index = 0;

      if (Object.hasOwnProperty.call(desc, key)) {
        var path = desc[key];
        var val = (0, _utils.isObject)(value) ? value[key] : (0, _utils.isArray)(value) ? value[index] : value;
        (0, _utils.setObjByPath)(obj.bind, path, val, false);
      }
    }
  } else if ((0, _utils.isArray)(desc)) {
    for (var _index = 0; _index < desc.length; _index++) {
      var _path = desc[_index];

      var _val = (0, _utils.isObject)(value) ? value[_path] : (0, _utils.isArray)(value) ? value[_index] : value;

      (0, _utils.setObjByPath)(obj.bind, _path, _val, false);
    }
  }
}
/**
 * 
 * @param {*} obj 
 * @param {*} checkExist 
 * @returns 
 */


function getValue(obj, checkExist) {
  var desc = obj.$in,
      value;

  if ((!desc || typeof desc === "string" && desc.trim() === "") && obj.name) {
    desc = obj.name;
  }

  if (desc && typeof desc === 'string') {
    desc = desc.match(/[,|]+/) ? desc.split(/[,|]+/) : desc;
  }

  if (typeof desc === "function") {
    value = desc(obj.bind);
  } else if (typeof desc === 'string' && desc.length) {
    value = (0, _utils.getObjByPath)(desc, obj.bind, checkExist);
  } else if ((0, _utils.isObject)(desc)) {
    value = {};

    for (var key in desc) {
      if (Object.hasOwnProperty.call(desc, key)) {
        var path = desc[key];
        value[key] = (0, _utils.getObjByPath)(path, obj.bind, checkExist);
      }
    }
  } else if ((0, _utils.isArray)(desc)) {
    value = [];

    for (var index = 0; index < desc.length; index++) {
      var _path2 = desc[index];
      value[index] = (0, _utils.getObjByPath)(_path2, obj.bind, checkExist);
    }
  }

  return value;
} // /**
//   绑定描述符号
// */


var Desc = /*#__PURE__*/function () {
  // 被绑定的属性名称
  // 绑定的对象
  // $in描述符号
  // $out描述符号
  // 0,1,2 分别表示in,out, inout
  function Desc(bind) {
    _classCallCheck(this, Desc);

    this.name = void 0;
    this.bind = void 0;
    this.$in = void 0;
    this.$out = void 0;
    this.type = void 0;
    this.isObservable = false;
    this.attach = void 0;
    this.isNewExtendObservable = false;
    this.oldValue = void 0;
    this._events = {};
    this.type = 2;
    this.bind = bind;
    this.isObservable = (0, _mobx.isObservable)(bind);
  }
  /**
   * 是否已绑定store
   * @returns 
   */


  _createClass(Desc, [{
    key: "hasBind",
    value: function hasBind() {
      return _typeof(this.bind) == "object" && this.bind !== null;
    } // 判断读取能力

  }, {
    key: "canGet",
    value: function canGet() {
      return this.type === 2 || this.type === 0;
    } // 判断写能力

  }, {
    key: "canSet",
    value: function canSet() {
      return this.type === 2 || this.type === 1;
    }
  }, {
    key: "get",
    value: function get(checkExist) {
      // get方法
      if (!this.hasBind()) {
        throw new Error("store should be binded with a object and not null");
      }

      if (!this.canGet()) {
        throw new Error("not support");
      }

      this.isNewExtendObservable = false;
      var value = getValue(this, checkExist);
      this.oldValue = value;
      return value;
    }
  }, {
    key: "set",
    value: function set(value, actionName) {
      // set方法
      if (!this.hasBind()) {
        throw new Error("store should be binded with a object and not null");
      }

      if (!this.canSet()) {
        throw new Error("not support");
      }

      this.isNewExtendObservable = this.isNewExtendObservable || false;
      var aname = actionName === true ? ACTION_NAME_DESC_COMPONENT : typeof actionName === 'string' && actionName ? actionName : ACTION_NAME_DESC;
      setValue(this, value, aname);
      this.trigger('set');
    } // 判断是否相等

  }, {
    key: "equals",
    value: function equals(other) {
      if (!this.canGet()) {
        return false;
      }

      var otherValue = other,
          value = this.get();

      if ($isDesc(other)) {
        if (!other.canGet()) {
          return false;
        }

        otherValue = other.oldValue;
      }

      return otherValue === value;
    }
  }, {
    key: "on",
    value: function on(event, hanlder) {
      this._events[event] = this._events[event] || [];

      if (typeof hanlder === 'function' && this._events[event].indexOf(hanlder) === -1) {
        this._events[event].push(hanlder);
      }
    }
  }, {
    key: "off",
    value: function off(event, halder) {
      this._events[event] = this._events[event] || [];

      var index = this._events[event].indexOf(halder);

      if (index > -1) {
        delete this._events[event][index];
      } else if (!halder) {
        this._events[event] = [];
      }
    }
  }, {
    key: "trigger",
    value: function trigger(event, args) {
      this._events[event] = this._events[event] || [];

      for (var index = 0; index < this._events[event].length; index++) {
        var fn = this._events[event][index];
        fn.apply(this, args || []);
      }
    }
  }]);

  return Desc;
}();
/**
 * 读的调用方法
 * @param {*} get 
 */


function $in(get, bind) {
  var desc = new Desc(bind); // 要求对象必须是 observable

  desc.$in = get;
  desc.type = 0;
  return desc;
}
/**
 * 写的调用方法
 * @param {*} set 
 */


function $out(set, bind) {
  // 不要求对象必须是 observable
  var desc = new Desc(bind);
  desc.$out = set;
  desc.type = 1;
  return desc;
}
/**
 * 读写的调用方法
 * @param {*} get 
 * @param {*} set 
 */


function $inout(get, set, bind) {
  // 要求对象必须是 observable
  if ((!set || typeof set !== 'string') && typeof get !== "function") {
    bind = set;
    set = get;
  }

  var desc = new Desc(bind);
  desc.$in = get;
  desc.$out = set;
  desc.type = 2;
  return desc;
}

function parseReactionLog(reaction) {
  if (reaction && reaction.observing && reaction.observing.length) {
    reaction.observing.map(function (observing) {
      console.log(observing.name + ' ->', observing.value);
    });
  }
}
/**
 * 观察外部对象的变化
 * @param {*} $sui 
 * @param {*} key 
 * @param {*} maping 
 */


function watchOutObjChange($sui, key, maping) {
  if ($sui.auto.hasOwnProperty(key)) {
    return;
  }

  maping.get(true); // 根据mobx autorun 只会观察在执行提供的函数时所使用的数据的特性，须检查并扩展bind的相应的path; 否则无法观察外部变化

  $sui.auto[key] = (0, _mobx.autorun)(function () {
    var scope = maping;
    return function (reaction) {
      parseReactionLog(reaction);
      var val = scope.get();
      $sui.props[key] = val;
      $sui.onchange && $sui.onchange(key, val);
      $sui.update && $sui.update();
    };
  }());
}
/**
 * props重写、拦截
 * @param {*} props 
 */


var $attrs = function $attrs(props) {
  var obj = {
    $sui: {
      store: {},
      props: props,
      restProps: {},
      mapings: {},
      hasMapping: false,
      auto: {},
      onchange: null,
      update: null,
      reset: function reset() {
        for (var runKey in this.auto) {
          this.auto[runKey]();
          this.auto[runKey] = null;
        }

        this.auto = {};

        if (this.onchange) {
          this.onchange = null;
        }

        if (this.update) {
          this.update = null;
        }

        this.hasMapping = false;
      },
      // 属性绑定
      attach: function attach(_args, component, context, from) {
        component.name = _args.name;
        component.names = _args.names;
        component.verifyResult = component.verifyResult || {};
        component.uuid = component.uuid || 'sui-component-' + (0, _utils.uuid)();
        var suid = component.uuid; // reset

        this.reset();
        this.store = this.store || {};

        var bind = _args.bind,
            args = _objectWithoutProperties(_args, _excluded);

        if (context && context.mobxStores) {
          if (!bind && context.mobxStores.bind) {
            bind = context.mobxStores.bind;
          }

          if (context.mobxStores.formMap && !context.mobxStores.formMap.has(suid)) {
            context.mobxStores.formMap.set(suid, component);
          }
        } // 读取 store


        if (_typeof(bind) === 'object' && bind !== null) {
          this.store = bind;
        } // 构造映射关系


        var mapings = {};

        for (var key in args) {
          var value = args[key];

          if ($isDesc(value)) {
            var _bind = value.bind || this.store || {};

            value.bind = _bind;
            value.name = key;
            value.isObservable = (0, _mobx.isObservable)(_bind);
            mapings[key] = value;
            value.attach = this;
            value.trigger('attach', [from]);
            this.hasMapping = true;
          } else if (this.props.hasOwnProperty(key)) {
            this.props[key] = value;
          } else if (key !== "bind") {
            // 过滤掉 bind store
            this.restProps[key] = value;
          }
        }

        var that = this;

        for (var _key in mapings) {
          var maping = mapings[_key];

          if (maping.canGet() && maping.isObservable) {
            // 观察外部属性变化
            watchOutObjChange(that, _key, maping);
          }
        }

        this.onchange = function (prop) {
          if (component.mounted !== false) {
            prop === 'value' && component.verify && component.verify('change');
          }
        };

        this.update = function () {
          if (component.mounted !== false) {
            component.forceUpdate();
          }
        };

        this.mapings = mapings;
      },
      // 比较属性是否发生变化
      compareProps: function compareProps(props, state, nextProps, nextState) {
        if (props === nextProps && state === nextState) {
          return '';
        }

        if (state !== nextState) {
          return 'state changed';
        }

        var key, value, otherValue;
        var temp = Object.assign({}, nextProps);

        for (key in props) {
          value = props[key];
          otherValue = temp[key];
          delete temp[key];

          if (otherValue === value) {
            continue;
          } //两个满足条件Desc对象才会相等，否则不相等


          if ($isDesc(otherValue) && otherValue.equals(value)) {
            continue;
          }

          return 'prop [' + key + '] changed';
        }

        for (key in temp) {
          return 'props changed';
        }

        return '';
      }
    }
  }; // 重新定义属性的getset方法，实现双向绑定

  var _loop = function _loop(k) {
    Object.defineProperty(obj, k, {
      enumerable: true,
      get: function () {
        var key = k;
        return function () {
          var maping = obj.$sui.mapings[key];
          var val = obj.$sui.props[key];

          if (maping && maping.canGet()) {
            val = maping.get();
          }
          /**
           * 兼容处理readonly 样式
           */


          if (key === "disabled" && !val) {
            return obj['readOnly'] ? true : false;
          }

          return val;
        };
      }(),
      set: function () {
        var key = k;
        return function (value) {
          obj.$sui.props[key] = value;
          var maping = obj.$sui.mapings[key];

          if (maping && maping.canSet()) {
            try {
              maping.set(value, true);
            } catch (error) {
              console.log(error);
            }
          } else {
            obj.$sui.onchange && obj.$sui.onchange(key, value);
            obj.$sui.update && obj.$sui.update();
          }
        };
      }()
    });
  };

  for (var k in props) {
    _loop(k);
  }

  return obj;
};

exports.$attrs = $attrs;

function $isDesc(obj) {
  return !!(obj && obj instanceof Desc);
}

var _default = {
  $attrs: $attrs,
  $in: $in,
  $inout: $inout,
  $out: $out,
  $isDesc: $isDesc
};
exports.default = _default;